import { makeAutoObservable, runInAction } from "mobx";
import {
  pagingMedicationRecordSheet,
  getViewEncounterById,
} from "./MedicationRecordSheetService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import i18n from "i18n";

export default class MedicationRecordSheetStore {
  medicationRecordSheetList = [];
  selectedMedicationRecordSheet = null;
  selectedMedicationRecordSheetList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  keyword = "";
  statusAdsm = null;
  loadingInitial = false;
  shouldOpenPrintPreviewDialog = false;
  searchObject = {
    fromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    toDate: new Date(),
  };
  listToPrint = []

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  handleSetSearchObject = (item) => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
    }
    this.searchObject = item;
  };

  updatePageData = (item) => {
    if (item != null) {
      this.page = 1;
      this.keyword = item.keyword;
      this.search();
    } else {
      this.search();
    }
  };

  search = async () => {
    this.loadingInitial = true;
    var searchObject = {
      ...this.searchObject,
      keyword: this.keyword,
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
    };

    try {
      let data = await pagingMedicationRecordSheet(searchObject);
      runInAction(() => {
        this.medicationRecordSheetList = data.data.content;
        this.totalElements = data.data.totalElements;
        this.totalPages = data.data.totalPages;
        this.setLoadingInitial(false);
      })
    } catch (error) {
      console.log(error);
      toast.warning("toast.load_fail");
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleClose = () => {
    this.shouldOpenPrintPreviewDialog = false;
    this.selectedMedicationRecordSheetList = []
    this.updatePageData();
  };

  handleSelectMedicationRecordSheet = (obj) => {
    this.selectedMedicationRecordSheet = obj;
  };

  resetSearchObject = () => {
    this.searchObject = {
      fromDate: null,
      toDate: null
    }
    this.keyword = "";
    this.page = 1;
    this.rowsPerPage = 10;
  }

  handleSelectListMedicationRecordSheet = list => {
    this.selectedMedicationRecordSheetList = [...list]
  }

  handlePrintSelected = UUIDs => {
    getViewEncounterById(UUIDs).then(({data}) => {
      runInAction(() => {
        this.shouldOpenPrintPreviewDialog = true;
        this.listToPrint = data;
      })
    }).catch(e => {
      console.error(e);
      toast.warn(i18n.t("toast.error"))
    })
  }
}
